/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodBankAdverseEvent from './blood-bank-adverse-event';
import BloodBankAdverseEventDetail from './blood-bank-adverse-event-detail';
import BloodBankAdverseEventUpdate from './blood-bank-adverse-event-update';
import BloodBankAdverseEventDeleteDialog from './blood-bank-adverse-event-delete-dialog';

const BloodBankAdverseEventRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodBankAdverseEvent />} />
    <Route path="new" element={<BloodBankAdverseEventUpdate />} />
    <Route path=":id">
      <Route index element={<BloodBankAdverseEventDetail />} />
      <Route path="edit" element={<BloodBankAdverseEventUpdate />} />
      <Route path="delete" element={<BloodBankAdverseEventDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodBankAdverseEventRoutes;
